/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Auth_Api_Errors_Passkey_InvalidInputs */

const nl_auth_api_errors_passkey_invalid = /** @type {(inputs: Auth_Api_Errors_Passkey_InvalidInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Inloggen met passkey is mislukt. Probeer het opnieuw of log in met je wachtwoord.`)
};

/**

* @param {Auth_Api_Errors_Passkey_InvalidInputs} inputs
* @param {{ locale?: "nl" }} options
* @returns {LocalizedString}
*/
const auth_api_errors_passkey_invalid = /** @type {((inputs?: Auth_Api_Errors_Passkey_InvalidInputs, options?: { locale?: "nl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Auth_Api_Errors_Passkey_InvalidInputs, { locale?: "nl" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return nl_auth_api_errors_passkey_invalid(inputs)
});
export { auth_api_errors_passkey_invalid as "auth.api_errors.passkey_invalid" }